// jednoduché CRUD přes localStorage pro serialy/filmy
const KEY = 'nce_media_store_v1';

/**
 * uložená struktura: { serials: [...], films: [...] }
 * položka: { title, img, link, year? }
 */

async function readStore() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : { serials: [], films: [] };
    } catch (e) {
        return { serials: [], films: [] };
    }
}

async function writeStore(data) {
    try {
        localStorage.setItem(KEY, JSON.stringify(data || { serials: [], films: [] }));
        return data;
    } catch (e) {
        return data;
    }
}

export async function getItems(kind = 'serial') {
    const s = await readStore();
    return kind === 'film' ? (s.films || []) : (s.serials || []);
}

export async function addItem(kind = 'serial', item) {
    const s = await readStore();
    if (!s.serials) s.serials = [];
    if (!s.films) s.films = [];
    const arr = kind === 'film' ? s.films : s.serials;
    arr.unshift(item);
    await writeStore(s);
    return arr;
}

export async function updateItem(kind = 'serial', index, item) {
    const s = await readStore();
    const arr = kind === 'film' ? s.films : s.serials;
    if (Array.isArray(arr) && index >= 0 && index < arr.length) {
        arr[index] = item;
        await writeStore(s);
    }
    return arr;
}

export async function removeItem(kind = 'serial', index) {
    const s = await readStore();
    const arr = kind === 'film' ? s.films : s.serials;
    if (Array.isArray(arr) && index >= 0 && index < arr.length) {
        arr.splice(index, 1);
        await writeStore(s);
    }
    return arr;
}

export async function clearAll() {
    await writeStore({ serials: [], films: [] });
    return { serials: [], films: [] };
}

// Bulk replace items for a kind (used for cleanup/migrations)
export async function setItems(kind = 'serial', items = []) {
    const s = await readStore();
    if (!s.serials) s.serials = [];
    if (!s.films) s.films = [];
    if (kind === 'film') s.films = Array.isArray(items) ? items : [];
    else s.serials = Array.isArray(items) ? items : [];
    await writeStore(s);
    return kind === 'film' ? s.films : s.serials;
}